import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import MandateStatus from "./MandateStatus";
import RecentTransactions from "./RecentTransactions";
import UpcomingTransactions from "./UpcomingTransactions";
import PaymentPlan from "./PaymentPlan";
import BankDetails from "./BankDetails";
import { Box, Tabs, Tab } from "@mui/material";

import { fetchEMandateTransactionSummary } from "../../Services/Allotment";
import { useLocation } from "react-router-dom";

const EMandateDashboard = ({ allotmentPaymentId }) => {
  const location = useLocation();
  const mandateRegistrationData = location.state?.mandateRegistrationData;
  const [selectedMandate, setSelectedMandate] = useState("all"); // Default to 'all'
  const [bankDetails, setBankDetails] = useState();
  const [transactions, setTransactions] = useState([]);
  const [filteredMandateData, setFilteredMandateData] = useState([]);

  console.log("mandateRegistrationData", mandateRegistrationData);
  // console.log("allotmentpaymentId", allotmentPaymentId);

  const selectedMandateData = mandateRegistrationData.find(
    (mandate) => mandate.mandateId === selectedMandate,
  );
  console.log("selectedMandateData", selectedMandateData);

  useEffect(() => {
    const fetchTransactionSummary = async () => {
      // Ensure selectedMandateData is an object and has the mandateId
      if (selectedMandateData && selectedMandateData.mandateId) {
        try {
          // Fetch transaction summary only for the selected mandate
          const transactionSummaryAction =
            await fetchEMandateTransactionSummary([selectedMandateData]);
          setTransactions(transactionSummaryAction?.data);
          // console.log("transactionSummaryAction", transactionSummaryAction);

          // Set bank details based on the first valid mandate's transaction data
          setBankDetails(transactionSummaryAction?.data[0]?.mandate);
        } catch (error) {
          // console.error("Error fetching transaction summary:", error);
        }
      } else {
        console.log("No valid mandate data available.");
      }
    };

    fetchTransactionSummary();
    // console.log("first", selectedMandateData);
  }, [selectedMandateData]);

  useEffect(() => {
    // Filter mandate data where isRegistered is true
    const filteredData = mandateRegistrationData.filter(
      (mandate) => mandate.isRegistered === true,
    );
    setFilteredMandateData(filteredData);

    // Set the first filtered mandate as selected by default
    if (filteredData.length > 0) {
      setSelectedMandate(filteredData[0].mandateId);
    }
  }, [mandateRegistrationData]);

  const handleTabChange = (event, newValue) => {
    setSelectedMandate(newValue); // Update selected mandate on tab change
  };

  // if (loading) {
  //   return <Typography>Loading...</Typography>; // Display loading state
  // }

  return (
    <div
      style={{
        height: "100%",
        overflowY: "auto",
        padding: "16px",
        maxWidth: "100vw",
        boxSizing: "border-box",
      }}
    >
      {/* PAGE HEADER */}
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 24, fontWeight: 600, marginBottom: 4 }}>
          E-Mandate Overview
        </h1>
        <p style={{ color: "#757575", fontSize: 14 }}>
          View and manage your e-mandate settings and transactions
        </p>
      </div>

      {/* Mandate Selection Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={selectedMandate}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTab-root": {
              fontSize: "1rem", // Default font size for larger screens
              textTransform: "none",
              minHeight: 48,
              "@media (max-width: 768px)": {
                fontSize: "1.9rem !important", // Increase font size on mobile (important)
              },
            },
            "& .MuiTabs-scrollable": {
              overflowX: "auto", // Ensures horizontal scrolling
            },
          }}
        >
          {/* {mandateRegistrationData?.map((mandate) => (
            <Tab
              key={mandate.mandateId}
              value={mandate.mandateId}
              label={
                mandate.name
                  ? `${mandate.name} - (${mandate.splitRatio}%) `
                  : ""
              }
            />
          ))} */}

          {mandateRegistrationData?.map((mandate) => {
            // console.log("mandate in tab", mandate);
            const isSplit = mandate.isSplit;

            // Condition for isSplit = true
            if (isSplit) {
              // console.log("isSplit is true");

              // Get all applicants with valid splitRatio values that sum up to 100%
              const totalSplitRatio = mandateRegistrationData
                .filter((m) => m.splitRatio) // Filter out any undefined or null splitRatio values
                .reduce((acc, curr) => acc + curr.splitRatio, 0); // Sum the splitRatio values

              // console.log("totalSplitRatio", totalSplitRatio);

              // Check if the total splitRatio equals 100% (we allow for possible floating point issues)
              if (totalSplitRatio === 100) {
                // Loop through applicants and check if they are registered
                // if (mandate.isRegistered) {
                  return (
                    <Tab
                      key={mandate.mandateId}
                      value={mandate.mandateId}
                      label={`${mandate.name} - (${mandate.splitRatio}%)`}
                    />
                  );
                // }
              }
            }

            // Condition for isSplit = false
            else {
              // If isSplit is false, only show if splitRatio is 100%, isRegistered is true, and mandateId is not null
              if (
                mandate.splitRatio === 100 &&
                mandate.isRegistered &&
                mandate.mandateId
              ) {
                return (
                  <Tab
                    key={mandate.mandateId}
                    value={mandate.mandateId}
                    label={`${mandate.name} - (${mandate.splitRatio}%)`}
                  />
                );
              }
            }

            return null; // Return nothing if conditions don't match
          })}
        </Tabs>
      </Box>

      {/* Mandate Status */}
      {mandateRegistrationData.length > 0 && (
        <MandateStatus
          allotmentPaymentId={allotmentPaymentId}
          selectedMandateData={selectedMandateData}
        />
      )}

      {console.log("transactions on dashboard page --->", transactions)}
      {/* Dashboard Grid (Mobile-Friendly Layout) */}
      {filteredMandateData.length > 0 &&
        selectedMandateData?.isRegistered &&
        selectedMandateData?.emandateStatus !== "Deactivated" &&
        (transactions.length > 0 || bankDetails) && (
          <div
            className="dashboard-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr", // Two columns layout by default
              gap: 24,
              marginBottom: 24,
            }}
          >
            <UpcomingTransactions transactions={transactions} />
            {bankDetails && <BankDetails bankDetails={bankDetails} />}
          </div>
        )}

      {/* Payment Plan & Recent Transactions */}
      {filteredMandateData.length > 0 &&
        selectedMandateData?.isRegistered &&
        (transactions.length > 0 || bankDetails) && (
          <div style={{ marginBottom: 24 }}>
            <PaymentPlan plansInstallments={transactions} />
            <RecentTransactions transactions={transactions} />
          </div>
        )}

      {/* RESPONSIVE RULES */}
      <style>{`
    @media (max-width: 768px) {
      html, body {
        overflow-x: hidden !important;
        max-width: 100vw !important;
      }

      * {
        box-sizing: border-box;
      }
    }

    @media (max-width: 900px) {
      .dashboard-grid {
        grid-template-columns: 1fr !important; /* Stack components on smaller screens */
      }
    }

    @media (max-width: 600px) {
      h1 {
        font-size: 20px !important; /* Adjust header size for mobile */
      }

      p {
        font-size: 12px !important; /* Adjust paragraph font size for mobile */
      }

      .MuiTab-root {
        font-size: 1rem !important; /* Adjust tab font size for mobile */
      }
    }
  `}</style>
    </div>
  );
};

export default EMandateDashboard;